<template>
	<div class="Aviso">
		<headNav :activeNav="'Aviso'"></headNav>

		<div class="banner"></div>
		<div class="bigContent">
			<div class="content">
				<p class="title">Última actualización: 21 de julio de 2025</p>
				<p>Resumen de la actualización</p>
				<p>
					Hemos realizado las siguientes optimizaciones y ajustes en los permisos y el procesamiento de datos de la
					aplicación:
				</p>
				<p>Ajustes en los permisos</p>
				<p>
					- Se eliminaron permisos innecesarios, incluidos los permisos de Lista de aplicaciones (AppList) y Calendario.
					Estos permisos ya no se recopilan ni se solicitan.
				</p>
				<p>Ya no se recopila información específica del dispositivo</p>
				<p>
					- Identificadores de dispositivos como Android ID, IMEI y dirección MAC ya no se recopilan. Esta información
					no se utilizará para ningún propósito ni será accesible para la aplicación.
				</p>
				<p>Uso conforme de los permisos de SMS</p>
				<p>
					- Solo conservamos un permiso limitado para leer el contenido de SMS, restringido estrictamente a mensajes
					relacionados con servicios financieros (como los de bancos o instituciones financieras). Este permiso se
					utiliza únicamente para escenarios de prevención de fraudes y control de riesgos, como la identificación de
					transacciones anómalas, garantizando la seguridad de su cuenta.
				</p>
				<p>&nbsp;</p>
				<p>
					ESTA POLÍTICA DE PRIVACIDAD (“Política”) ha sido redactada de conformidad con la Ley de Tecnologías de la
					Información vigente y las Reglas de Tecnologías de la Información (Prácticas y procedimientos de seguridad
					razonables y datos o información personal sensible) y demás Reglas y Reglamentos aplicables enmarcados al
					respecto.
				</p>
				<p>
					El usuario no puede hacer la solicitud a través de la Website, solo vía app por lo que necesita descargarla.
					Al navegar o usar la aplicación para dispositivos móviles, reconoce que ha leído, entendido y se obliga a
					cumplir con la presente Política de Protección de Tratamiento de Datos Personales de Dinerbacano, con los
					términos y condiciones de la compañía, y cumplir con todas las leyes y reglamentos aplicables en la materia,
					si el usuario no está de acuerdo con los términos y condiciones de uso o con cualquier disposición de la
					política de privacidad y tratamiento de datos personales, le sugerimos que se abstenga de acceder o usar
					nuestra aplicación para dispositivos móviles, y de usar los productos y servicios que se presentan en el
					mismo.
				</p>
				<p class="title">RECOPILACIÓN DE INFORMACIÓN DEL DISPOSITIVO</p>
				<p>
					La información que recopila la aplicación y cómo se usa esa información depende de cómo administre sus
					controles de privacidad en su dispositivo.
				</p>
				<p>
					Cuando instala la aplicación, almacenamos la información que recopilamos con identificadores únicos vinculados
					al dispositivo que está utilizando.
				</p>
				<p>
					Recopilamos información del dispositivo cuando descarga e instala la aplicación y solicitamos explícitamente
					su permiso para obtener la información requerida del dispositivo.
				</p>
				<p>
					La información que recopilamos de su dispositivo incluye el modelo del teléfono, la marca del dispositivo, la
					versión del sistema operativo, la versión del SDK, el estado de la red (conectado o no) y el tipo de red móvil
					(como 4G o Wi-Fi), así como la configuración regional e idioma del sistema.
				</p>
				<p>
					Recopilamos información sobre su dispositivo para proporcionar actualizaciones automáticas y seguridad
					adicional para que su cuenta no se utilice en los dispositivos de otras personas. Además, la información nos
					brinda información valiosa sobre su identidad como titular de un dispositivo, así como sobre el comportamiento
					de su dispositivo, lo que nos permite mejorar nuestros servicios y brindarle una experiencia de usuario
					mejorada y personalizada.
				</p>
				<p class="title">Solicitud de ID de publicidad: Optimización de los anuncios</p>
				<p>
					Para optimizar el rendimiento de los anuncios, recopilamos el ID de publicidad de Google, lo que nos ayuda a
					medir el desempeño de las campañas publicitarias. Al recolectar estos datos, podemos evaluar métricas
					importantes como la tasa de clics, la tasa de conversión, entre otros, para mejorar el contenido y la forma de
					presentación de los anuncios.
				</p>
				<p class="title">INFORMACIÓN SMS</p>
				<p>
					Solo recopilamos mensajes SMS relacionados con temas financieros, como notificaciones de transacciones o
					alertas de cuenta enviadas por bancos u otras entidades financieras. Todos los datos de SMS se cifran en el
					dispositivo y se cargan de forma segura a nuestro servidor miembro
					<span style="color: #0000ff">
						https://api.dinerbacano.co/
					</span>
					a través del protocolo HTTPS. En el servidor, filtramos automáticamente y eliminamos cualquier mensaje que no
					sea de carácter financiero, conservando únicamente la información relevante como el número y nombre del
					remitente, el contenido del mensaje y su historial. Esta información nos permite identificar los tipos de
					cuentas bancarias del usuario, sus patrones de flujo de efectivo y actividad financiera, para realizar
					evaluaciones de riesgo crediticio y proporcionar un análisis adecuado. Nos comprometemos a no compartir esta
					información con terceros en ningún momento.
				</p>
				<p class="title">NÚMERO DE MÓVIL Y DIRECCIÓN DE CORREO ELECTRÓNICO</p>
				<p>
					Cuando se registra con nosotros, recopilamos su número de teléfono móvil y dirección de correo electrónico
					para identificarlo de manera única. Esto nos ayuda a garantizar que ningún dispositivo o persona no
					autorizados actúe en su nombre.
				</p>
				<p class="title">COLECCIÓN DE UBICACIÓN</p>
				<p>
					Recopilamos información de ubicación de su dispositivo para reducir el riesgo asociado con su cuenta. Usted
					comprende y reconoce que nos reservamos el derecho de rastrear su ubicación (Rastrear) durante la prestación
					de los Servicios, y también en el caso de que detenga, cese, dejar de usar o hacer uso de los Servicios,
					mediante la eliminación o desinstalación de la aplicación móvil o de otra manera, hasta el caso de que sus
					obligaciones continúen existiendo. La eliminación, desinstalación y/o interrupción de nuestros Servicios no lo
					eximirá de la responsabilidad, obligación y responsabilidad de pagar la(s) Cantidad(es) Pendiente(s).
				</p>
				<p class="title">CÁMARA</p>
				<p>
					Requerimos el permiso de información de la cámara para brindarle una experiencia fácil y fluida y para
					permitirle hacer clic en las fotos de sus documentos KYC junto con otros documentos requeridos y cargarlos en
					la aplicación durante el viaje de su solicitud de préstamo.
				</p>
				<p class="title">RECOPILACIÓN DE OTRA INFORMACIÓN NO PERSONAL</p>
				<p>
					Rastreamos automáticamente cierta información sobre usted en función de su comportamiento en nuestra
					Plataforma. Utilizamos esta información para realizar investigaciones internas sobre nuestros usuarios.
				</p>
				<p class="title">RECOPILACIÓN DE INFORMACIÓNNN</p>
				<p>
					Cuando utiliza nuestra Aplicación móvil, recopilamos y almacenamos su información (información personal) que
					usted proporciona de vez en cuando al solicitarle explícitamente permisos para obtener la información
					requerida. Nuestro objetivo principal al hacerlo es brindarle una experiencia y servicios seguros, eficientes,
					fluidos y personalizados. Esto nos permite brindar servicios y funciones que satisfagan sus necesidades y
					personalizar nuestra Plataforma para que su experiencia sea más segura y fácil y para mejorar los servicios
					que brindamos. Más importante aún, recopilamos información personal de usted que consideramos necesaria para
					lograr el propósito antes mencionado.
				</p>
				<p>
					Para crear una cuenta en la APLICACIÓN, debe proporcionarnos cierta información básica requerida para brindar
					servicios personalizados. Durante su uso de la plataforma, la aplicación o el sitio web, recopilaremos dicha
					información de usted, que incluye, entre otros:
				</p>
				<p>A. Nombre completo</p>
				<p>B. Número de teléfono</p>
				<p>C. Información y fotos de C.C.ID</p>
				<p>D. Fecha de nacimiento (Opcional)</p>
				<p>
					E. Información de contacto (que incluye, entre otros, la información de su número de teléfono, la lista de
					contactos)
				</p>
				<p>F. Estado civil</p>
				<p>
					G. Nombre del banco donde tiene una cuenta principal, extractos bancarios, etc.
				</p>
				<p>H. Datos de facturación</p>
				<p>
					I. Información sobre Su historial de transacciones, a través de nuestra aplicación móvil;
				</p>
				<p>
					J. Información de características físicas como fotos del poseedor de los datos
				</p>
				<p>
					Siempre que sea posible, indicamos los campos obligatorios y los opcionales. Siempre tiene la opción de no
					proporcionar su información personal eligiendo no usar un servicio o función en particular en la Plataforma.
					También recopilamos otra información identificable (los detalles de su tarjeta de pago y el historial de
					transacciones en la Plataforma) cuando configura una cuenta con nosotros. Además, en determinadas condiciones,
					subimos sus fotos de identificación y sus propias fotos de retrato cargadas a nuestros servidores, que se
					transmiten encriptadas y no se envían a terceros. Si bien puede navegar por algunas secciones de nuestra
					Plataforma sin compartir sus datos personales, sin embargo, para ciertas actividades/servicios (como hacer uso
					de préstamos de terceros prestamistas en la Plataforma) es necesario registrarse y proporcionar los detalles
					anteriores. La Plataforma mostrará claramente la información personal que recopila de usted, y usted tiene la
					opción de no proporcionar dicha información personal. Sin embargo, la información que recopilamos sobre usted
					dependerá de los productos y servicios que ofrecemos o que utiliza, de manera continua. La información
					recopilada de usted se utilizará para brindarle servicios de manera efectiva. Si no nos permite recopilar toda
					la información que solicitamos en la Plataforma, es posible que no podamos brindar todos estos servicios de
					manera efectiva.
				</p>
				<p>
					Para optimizar los resultados publicitarios y mejorar la precisión de las campañas, utilizamos Appsflyer como
					herramienta de atribución de anuncios. Appsflyer recopila los siguientes datos para analizar el comportamiento
					del usuario:
				</p>
				<p class="title">Clics en anuncios y conversiones</p>
				<p>
					Seguimiento de los clics en los anuncios y la instalación de la aplicación.
				</p>
				<p class="title">Información del dispositivo</p>
				<p>Incluye el modelo del dispositivo, la versión del sistema operativo, dirección IP, etc.</p>
				<p class="title">Datos de actividad del usuario</p>
				<p>Seguimiento de las interacciones del usuario dentro de la aplicación.</p>
				<p class="title">Declaración:</p>
				<p>
					Aseguramos que no recopilamos datos sensibles de los usuarios. Los datos recopilados se utilizan
					exclusivamente para optimizar los anuncios y mejorar la experiencia del usuario.
				</p>

				<p class="title">
					¿CUÁL ES SU CONTROLc SOBRE SU INFORMACIÓN PERSONAL QUE SE RECOPILA Y UTILIZA EN LÍNEA?
				</p>
				<p>
					Es importante tener en cuenta que la información que usamos sobre usted nos ayuda a brindarle productos,
					servicios y experiencias que lo benefician. Tiene la capacidad de controlar cómo se recopila y utiliza en
					línea su información no personal.
				</p>
				<p>
					También tiene la capacidad de elegir qué información personal, incluida la información personal confidencial
					(es decir, su información financiera) que nos proporciona. Sin embargo, si elige no proporcionar toda la
					información y los datos que se le solicitan, es posible que no podamos brindarle los Servicios a los que se ha
					suscrito.
				</p>
				<p>
					Usted puede, en cualquier momento, mientras utiliza nuestros Servicios o de otro modo, retirar el
					consentimiento que nos ha otorgado anteriormente para recopilar y utilizar sus datos o información personal
					sensible escribiéndonos a {{ dataInfo.email }}. Sin embargo, en el caso de que retire dicho consentimiento,
					Dinerbacano tendrá la opción de dejar de brindarle los Servicios para los cuales se solicitó la información.
					No será elegible para el reembolso de las tarifas pagadas por ningún servicio en tal caso y acepta que el
					sitio web no será responsable ante usted por lo mismo de ninguna manera.
				</p>
				<p>
					Cuando proporcione sus datos de contacto, los utilizaremos para enviarle avisos generales o noticias
					importantes sobre su cuenta, solicitar sus comentarios u opiniones y brindarle actualizaciones sobre ofertas
					especiales y ofertas que puedan interesarle.
				</p>
				<p>
					Creemos que debería poder elegir qué tipo de información recibe por correo electrónico/SMS. Si no desea
					recibir materiales de marketing por correo electrónico/SMS, simplemente indique su preferencia en la
					información de contacto de su cuenta o en el enlace para darse de baja o darse de baja que se proporciona en
					nuestros correos electrónicos de marketing y también puede escribirnos a {{ dataInfo.email }} Tenga en cuenta
					que puede tomar alrededor de 10 días para procesar su solicitud. Tenga en cuenta que continuaremos
					notificándole por correo electrónico/SMS/a través de llamadas telefónicas con respecto a sus servicios con
					nosotros, incluso después de que haya optado por no participar.
				</p>
				<p>
					Puede revisar la información que nos ha proporcionado iniciando sesión en su cuenta en el sitio web y corregir
					o modificar cualquier información personal o datos personales confidenciales o información para asegurarse de
					que la información o los datos que nos proporcionó sean precisos y/o no deficientes. Dinerbacano no es
					responsable de la autenticidad de ninguna información personal o datos personales confidenciales o información
					proporcionada por usted o por un tercero.
				</p>
				<p class="title">CAMBIOS EN ESTA POLÍTICA DE PRIVACIDAD</p>
				<p>
					Dinerbacano se reserva el derecho de cambiar esta política de vez en cuando, a su exclusivo criterio. Podemos
					actualizar esta política de privacidad para reflejar los cambios en nuestras prácticas de información. Le
					animamos a revisar periódicamente. Verificar la fecha de vigencia a continuación le permite determinar si ha
					habido cambios desde la última vez que revisó el estado de cuenta.
				</p>
				<p>
					Los cambios y modificaciones estarán disponibles a través de los siguientes medios: anuncios en nuestras
					oficinas y en el portal web de Dinerbacano, a través de nuestro personal que recabe sus Datos Personales. Es
					aconsejable revisar el Aviso de Privacidad tras la enlace
					<span style="color: #0000ff">https://www.dinerbacano.co</span> para ser enterado de cada modificación que
					habrá en el futuro. Si tienen cualquier duda sobre el Aviso de Privacidad, por favor no duden en ponerse en
					contacto con atención al cliente tras WhatsApp ({{ dataInfo.client_whats_app }}) o correo electrónico ({{
						dataInfo.email
					}}).
				</p>

				<p class="title">OFICIAL DE QUEJAS</p>
				<p>
					Si tiene alguna inquietud con respecto a Dinerbacano o los servicios, comuníquese con:
				</p>
				<p>Identificación de correo electrónico: {{ dataInfo.email }}</p>
				<p>WhatsApp: {{ dataInfo.client_whats_app }}</p>
			</div>
		</div>
		<footPage></footPage>
	</div>
</template>

<script>
	import headNav from '@/components/headNav.vue'
	import footPage from '@/components/foot.vue'
	import '../components/scss/Aviso.scss'
	import infoList from '@/mixins/infoList'

	export default {
		name: 'Aviso',
		components: { headNav, footPage },
		mixins: [infoList],

		data() {
			return {}
		},
		mounted() {
			if (this.$route.query.value) {
				console.log(this.$route.query.value)

				const target = document.querySelector('#target')
				window.scrollTo({ top: target.offsetTop, behavior: 'smooth' })
			}
		},
		watch: {
			$route(value) {
				console.log(111)
				if (value.query.value) {
					const target = document.querySelector('#target')
					window.scrollTo({ top: target.offsetTop, behavior: 'smooth' })
				}
			},
		},
	}
</script>

<style scoped>
	.content_title {
		font-size: 18px !important;
		width: 576px;
		font-weight: 600 !important;
	}
	.Aviso p {
		margin-bottom: 20px;
	}
	.p-bottom {
		margin-bottom: 0 !important;
	}
	.title {
		font-size: 23px !important;
		margin-top: 15px;
		font-weight: 600;
	}
</style>
